import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import BaseUrl from "./Baseurl/Api";
import aboutimg from "../image/dharajbanner.jpg";

const BlogDetails = () => {
  const { id } = useParams();

  const [blog, setBlog] = useState([]); // array with single object
  const [relatedBlogs, setRelatedBlogs] = useState([]);

  // Fetch main blog
  useEffect(() => {
    BaseUrl.get(`/api/get_blogDetial/${id}`)
      .then((res) => {
        if (res.data?.Blog) {
          setBlog(res.data.Blog); // Blog is an array
        }
      })
      .catch((err) => console.log("Blog Error:", err));
  }, [id]);

  // Fetch related blogs
  useEffect(() => {
    BaseUrl.get(`/api/related_blog/${id}`)
      .then((res) => {
        if (res.data?.data) {
          setRelatedBlogs(res.data.data);
        }
      })
      .catch((err) => console.log("Related Error:", err));
  }, [id]);

  if (blog.length === 0) return <p className="text-center py-5">Loading...</p>;

  const main = blog[0]; // use first object

  return (
    <>
      {/* Hero Banner */}
     <section
  className="hero-banner position-relative"
  style={{ background: "#f3f3f3" }}
>
  {/* Banner Image */}
  <img
    src={`${BaseUrl.defaults.baseURL}/blogimage/${main.blogimage}`}
    alt={main.blogtitle}
    style={{
      width: "100%",
      height: "450px",
      objectFit: "cover",
      borderRadius: "0 0 30px 30px",
    }}
  />

  {/* Overlay */}
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.45)",
      borderRadius: "0 0 30px 30px",
    }}
  ></div>

  {/* Blog Title (Left + Center Vertical) */}
  <h1
    style={{
      position: "absolute",
      top: "50%",
      left: "40px",
      transform: "translateY(-50%)",
      color: "white",
      fontSize: "60px",
      fontWeight: "700",
      textAlign: "left",
      width: "70%",
      lineHeight: "1.3",
    }}
  >
    Blog Detail's
  </h1>
</section>



      {/* Title */}
      <section className="py-5">
        <div className="container text-center">
          <div
            style={{
              backgroundColor: "#ffffff",
              padding: "25px",
              borderRadius: "20px",
              boxShadow: "0 1px 10px rgba(0, 0, 0, 0.14)",
            }}
          >
<h3
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontWeight: 700,
    color: "#0F4D43",
    margin: "0",
  }}
>
  {/* Smooth Rounded Quote SVG */}
  <span style={{ width: "32px", height: "32px", display: "flex" }}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12C12 18 8 28 8 38C8 48 14 54 24 54C32 54 38 48 38 40C38 30 30 22 20 22V12ZM44 12C36 18 32 28 32 38C32 48 38 54 48 54C56 54 62 48 62 40C62 30 54 22 44 22V12Z"
        fill="url(#grad)"
      />
      <defs>
        <linearGradient id="grad" x1="0" y1="0" x2="64" y2="0">
          <stop stopColor="#00C98D" />
          <stop stopColor="#4BE3A5" offset="1" />
        </linearGradient>
      </defs>
    </svg>
  </span>

  {/* Title */}
  <span style={{ fontSize: "1.8rem" }}>{main.blogtitle}</span>
</h3>

 

          </div>
        </div>
      </section>

      {/* Blog Content */}
      <section>
        <div className="container mt-5">
          <div className="row">
            {/* Left: Blog */}
            <div className="col-lg-8 col-12">
              <img
                src={`${BaseUrl.defaults.baseURL}/blogimage/${main.blogimage}`}
                alt={main.blogtitle}
                className="w-100 rounded-4"
              />

              <h1 className="mt-4 fw-bold">{main.blogtitle}</h1>

              <p className="mt-3" style={{ fontSize: "18px", lineHeight: "1.7" }}>
                {main.blogdetail}
              </p>

              {/* Author */}
              <div className="d-flex align-items-center gap-3 mt-4">
                <img
                  src={`${BaseUrl.defaults.baseURL}/blogimage/${main.ownerimage}`}
                  alt={main.ownername}
                  className="rounded-circle"
                  style={{ width: "60px", height: "60px", objectFit: "cover" }}
                />
                <div>
                  <h5 className="mb-0 fw-bold">{main.ownername}</h5>
                  <small className="text-muted">{main.blogdate}</small>
                </div>
              </div>
            </div>

            {/* Right: Related Blogs */}
           <div className="col-lg-4 col-12 px-5  mt-4 mt-lg-0">
  <div className="card shadow rounded-4" style={{ backgroundColor: "#2A431C" }}>
    <div className="card-header border-0">
      <h5 className="text-white pt-2">Related Blogs</h5>
    </div>
    <div className="card-body">
      {relatedBlogs.length > 0 ? (
        relatedBlogs.map((item) => (
          <Link
            key={item.id}
            to={`/BlogDetails/${item.id}`}
            className="text-decoration-none"
          >
            <div
              className="card mb-3 shadow-sm rounded-4"
              style={{ cursor: "pointer", backgroundColor: "#ffffff" }}
            >
              {/* Image on top */}
              <img
                src={`${BaseUrl.defaults.baseURL}/blogimage/${item.blogimage}`}
                className="card-img-top rounded-top-4"
                alt={item.blogtitle}
                style={{ height: "180px", objectFit: "cover" }}
              />

              {/* Content below image */}
              <div className="card-body">
                <h6 className="card-title fw-bold text-dark fs-xl">{item.blogtitle}</h6>
                <p className="card-text text-muted" style={{ fontSize: "14px" }}>
                  {item.blogdetail?.slice(0, 80)}...
                </p>
              </div>
            </div>
          </Link>
        ))
      ) : (
        <p className="text-white">No related blogs found.</p>
      )}
    </div>
  </div>
</div>


          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
